import { HeadCellSortState } from '@foradevelopment/fora-ui';

import { TableSortId } from '../../../common/types';

export const defaultPayrollTableSortState = {
  [TableSortId.InactiveOrFokParameterChoices]: HeadCellSortState.None,
  [TableSortId.EmployeeId]: HeadCellSortState.None,
  [TableSortId.FirstName]: HeadCellSortState.None,
  [TableSortId.LastName]: HeadCellSortState.None,
  [TableSortId.Markup]: HeadCellSortState.None,
  [TableSortId.AttributablePay]: HeadCellSortState.None,
  [TableSortId.PayAmount]: HeadCellSortState.None,
  [TableSortId.HasError]: HeadCellSortState.None,
};

export type PayrollTableSortState = typeof defaultPayrollTableSortState;
export type PayrollTableSortId = keyof typeof defaultPayrollTableSortState;
